import type { LibP2pWithServices, NodeOptions } from '@/types/poc/libp2p';

export abstract class Libp2pService {
  abstract createNode(options: NodeOptions): Promise<LibP2pWithServices>;
  abstract stopNode(node: LibP2pWithServices): Promise<void>;
  abstract subscribeToTopic(
    node: LibP2pWithServices,
    topic: string,
    // `originPeerId` is the authenticated publisher (StrictSign), or null for an
    // unsigned message — callers must not trust a null origin for privileged actions.
    handler: (message: Uint8Array, originPeerId: string | null) => void
  ): () => void;
}
